

module dg.actions {
    export class DefaultListQueryOptionsProvider implements ng.IServiceProvider {
        private listOptions: IQueryInvokerOptions = {
            exportOptions: { title: "Download" }
        };
        // = {
        //    listToolsEnabled: true
        //};

        //public setGridType(type: string) {
        //    this.listOptions.type = type;

        //}
        //public setActionClolumnEnabled(isEnabled: boolean) {
        //    this.listOptions.actionColumnEnabled = isEnabled;

        //}

        public $get(): IQueryInvokerOptions {
            return this.listOptions;
        }
    }

    angular.module('dg.actions')
        .provider('DefaultListQueryOptions', DefaultListQueryOptionsProvider);
}